import React from 'react';
import { useGlobalSearch } from './useGlobalSearch';
import { EntityType } from './constants';
import { Select, Input, Spin, Empty, List, Avatar, Row, Typography } from 'components';
import styles from './styles.module.scss';

export const GlobalSearch = () => {
  const {
    selectedEntityType,
    searchText,
    showResults,
    isSearching,
    data,
    selectedEntity,
    handleEntityChange,
    handleSearchChange,
    handleItemClick,
    getTitle,
    getDescription,
    getAvatar,
    searchRef,
    setShowResults,
    filteredEntityTypesByPermissions,
  } = useGlobalSearch();

  return (
    <div className={styles.globalSearch} ref={searchRef}>
      <Row>
        <Select
          defaultValue="client"
          onChange={handleEntityChange}
          value={selectedEntityType}
          style={{ width: 220 }}
          options={filteredEntityTypesByPermissions.map((entity: EntityType) => ({
            value: entity.value,
            label: entity.label,
            disabled: entity?.disabled,
          }))}
        />
        <Input
          placeholder={`Search ${selectedEntity?.label} by ${selectedEntity?.searchBy}`}
          value={searchText}
          onChange={handleSearchChange}
          onFocus={() => setShowResults(true)}
          style={{ width: 250 }}
        />
      </Row>

      {showResults && searchText && (
        <div className={styles.searchResults}>
          {isSearching ? (
            <div className={styles.loadingContainer}>
              <Spin size="small">Searching...</Spin>
            </div>
          ) : data.length > 0 ? (
            <List
              itemLayout="horizontal"
              dataSource={data}
              renderItem={(item) => (
                <List.Item className={styles.resultItem} onClick={() => handleItemClick(item)}>
                  <List.Item.Meta
                    avatar={getAvatar(item) ? <Avatar src={getAvatar(item)} /> : null}
                    title={<Typography.Text ellipsis={{ tooltip: true }}>{getTitle(item)}</Typography.Text>}
                    description={<Typography.Text ellipsis={{ tooltip: true }}>{getDescription(item)}</Typography.Text>}
                  />
                </List.Item>
              )}
            />
          ) : (
            <Empty description="No results found" />
          )}
        </div>
      )}
    </div>
  );
};
